import { SideNav, SideNavContent } from "components";
import {
  HeaderDasNew,
  MainBody,
  OverlayLoader,
  PageTitle,
  Ptag,
} from "components/core";
import React, { useEffect, useState } from "react";
import BatchTable from "./BatchTable";
import http from "services/httpService";
import PageHeader from "components/UniversalComponents/PageHeader";

const EnrolmentHistory = () => {
  const isGmcFlow = localStorage.getItem("flow") === "GMC";

  const companyName = localStorage.getItem("company_name");
  const [enrolments, setEnrolments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async function () {
      await getEnrolments();
    })();
  }, []);

  const getEnrolments = async () => {
    let endpoint = "/business/get_all_tasksets/";
    if (isGmcFlow) {
      endpoint = "/business/get_batches_for_enrollment_history_gmc/";
    }
    try {
      setLoading(true);
      const { data } = await http.get(endpoint);
      setEnrolments(data);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading ? (
        <OverlayLoader />
      ) : (
        <>
          <SideNav>
            <SideNavContent />
          </SideNav>
          <HeaderDasNew company_name={companyName} />
          <MainBody>
            {/* <Ptag fontWeight="800" fontSize="20px" marginBottom="24px">
              Enrolment History
            </Ptag> */}
            <PageHeader header={"Enrolment History"} />
            <BatchTable enrolments={enrolments} isGmcFlow={isGmcFlow} />
          </MainBody>
        </>
      )}
    </>
  );
};

export default EnrolmentHistory;
